import React from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

function DraggableList({
  items, 
  onDrag, 
  onRemove 
}) {
  return (
    <DragDropContext 
      onDragEnd={(param) => {
        if (param.source && param.destination) {
          const srcIndex = param.source.index;
          const desIndex = param.destination.index;
          
          items.splice(desIndex, 0, items.splice(srcIndex, 1)[0]);

          onDrag(items);
        }
      }} 
    > 
      <Droppable droppableId={"droppableId1"}>
        {(provided, _) => (
          <div 
            ref={provided.innerRef} {...provided.droppableProps}
          >
            {items.map((item, index) => 
              <Draggable draggableId={"draggableId+"+item.id} index={index} key={item.id}>
                {(provided, snapshot) => (
                  <Card 
                    className="mb-3" 
                    ref={provided.innerRef} 
                    {...provided.draggableProps}
                    {...provided.dragHandleProps} 
                    style={{
                      ...provided.draggableProps.style, 
                      background: snapshot.isDragging ? "#efefef" : "inherit"}}
                  >
                    <Card.Body> 
                      <Row>
                        <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                          <FontAwesomeIcon icon={faBars} />
                        </Col>
                        <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                          <div>{item.title}</div>
                        </Col>
                        <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                          <Button className="float-right btn-icon" onClick={() => {
                            items.splice(index, 1);
                            onRemove(items);
                          }}>
                            <FontAwesomeIcon icon={faTimes} />
                          </Button>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                )}
              </Draggable>
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

export default DraggableList
